import { css } from "lit";

export const Style = css`
    * {
        --font-family: var(--ds-font-family, "Google Sans", Helvetica, Arial, sans-serif);
        --font-heading: var(--ds-heading-font-family, "Google Sans", Helvetica, Arial, sans-serif);
        --body-bg-color: var(--ds-body-bg-color, white);
        --body-color: var(--ds-body-color, rgb(32, 33, 36));
        --surface-bg-color: var(--ds-surface-bg-color, white);
        --surface-color: var(--ds-surface-color, --body-color);

        --default-error-color: var(--ds-default-error-color, orangered);
        --body-error-color: var(--ds-body-error-color, var(--default-error-color, pink));
        --surface-error-color: var(--ds-surface-error-color, var(--default-error-color, pink));

        --button-bg-color: var(--ds-button-bg-color, rgb(17, 74, 78));
        --button-color: var(--ds-button-color, var(--body-color));
        --accent-color: var(--ds-accent-color, #ffa500);
        --mast-background-color: var(--ds-mast-background-clr, #1a1a1e);

        --control-border-color: #48484f;

        --input-autocomplete-suggestion-bg-color: var(--body-bg-color);
        --input-autocomplete-suggestion-selected-background-color: var(--surface-bg-color);
        --input-autocomplete-suggestion-list-border: 1px solid var(--control-border-color);
        --input-autocomplete-suggestion-selected-border: 1px solid var(--control-border-color);
        --input-autocomplete-z-index: 1;
        --table-border: var(--ds-table-border, 2px var(--surface-bg-color) solid);

        --scrollbar-width: 8px;
        /* --scrollbar-track-bg-color: var(--surface-bg-color);
        --scrollbar-thumb-bg-color: #555; */
        --scrollbar-radius: 100px;
        --scrollbar-thumb-hover-bg-color: #888;

        --link-color: #add8e6;

        --flex-gap: 0.5em;

        --sl-color-primary-50: var(--ds-color-primary-50, rgb(253 249 245));
        --sl-color-primary-100: var(--ds-color-primary-100, rgb(249 234 223));
        --sl-color-primary-200: var(--ds-color-primary-200, rgb(244 217 198));
        --sl-color-primary-300: var(--ds-color-primary-300, rgb(238 199 171));
        --sl-color-primary-400: var(--ds-color-primary-400, rgb(231 174 134));
        --sl-color-primary-500: var(--ds-color-primary-500, rgb(221 141 84));
        --sl-color-primary-600: var(--ds-color-primary-600, rgb(209 101 25));
        --sl-color-primary-700: var(--ds-color-primary-700, rgb(181 76 0));
        --sl-color-primary-800: var(--ds-color-primary-800, rgb(150 63 0));
        --sl-color-primary-900: var(--ds-color-primary-900, rgb(107 45 0));
        --sl-color-primary-950: var(--ds-color-primary-950, rgb(67 28 0));

        --ds-accent-button-color: var(--sl-color-primary-600);

        --compass-width: 18em;
        --compass-height: 18em;

        --place-view-banner-splash-color: var(--ds-place-view-banner-splash-color, darkgreen);

        --ds-border: 1px solid #999;

        font-family: var(--ds-font-family, var(--font-family));
        background-color: var(--ds-body-bg-color);
    }

    html {
        box-sizing: border-box;
    }
    *,
    *:before,
    *:after {
        box-sizing: inherit;
    }

    a {
        cursor: pointer;
        text-decoration: underline;
        color: blue;
    }

    .surface-error-color {
        color: var(--surface-error-color);
    }

    .body-error-color {
        color: var(--body-error-color);
    }

    .link {
        color: var(--link-color);
        /* text-decoration-style: dotted;
        text-decoration-line: underline;
        text-decoration-color: var(--link-color); */
    }

    .btn-sm {
        padding: 0.5em;
        font-size: 1em;
        margin: 0.2em;
    }

    .button-row {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: right;
        align-content: center;
        column-gap: var(--flex-gap, 0.5em);
        row-gap: 0.5rem;
    }

    .selectable {
        cursor: pointer;
    }

    sl-split-panel {
        padding: 0rem !important;
    }

    sl-spinner {
        font-size: 50px;
        --track-width: 4px;
    }

    sl-dialog {
        --body-spacing: 1em;
        color: black;
    }

    .loading-spinner-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    button {
        padding: 1em;
        background-color: var(--button-bg-color);
        border: 0;
        color: var(--button-color);
        font-size: 1.25em;
        display: inline-block;
    }

    .fixed-header-container {
        height: 100%;
        overflow-y: none;
        min-height: 100%;
        padding: 0rem;

        display: flex;
        flex-direction: column;
    }

    .fixed-header-container .body {
        padding: 5px 5px 10px 5px;
        overflow-y: auto;
        flex: 1;
    }

    hr {
        border-top: 1px solid lightgrey;
    }

    .full-width-table-container {
        overflow-x: auto;
    }

    .full-width-table {
        width: 100%;
        padding: 0.5em;
        display: table !important;
        margin-left: 0em !important;
        border: 1px solid gray;
    }

    .full-width-table td {
        color: black;
        padding-top: 0.3em;
        padding-bottom: 0.3em;
        font-size: 0.9em;
        border: 1px solid gray;
    }

    .full-width-table tr:nth-child(even) {
        background-color: lightgray;
    }

    table {
        border: var(--table-border);
        border-collapse: collapse;
    }

    td {
        padding: 0.6em;
    }

    thead tr {
        background-color: var(--surface-bg-color);
    }

    sup {
        font-size: 0.7em;
        font-weight: normal;
        font-style: italic;
    }

    /* Fixed column grid layouts */
    .grid-2-column {
        display: grid;
        grid-template-columns: auto min-content;
        width: 100%;
        gap: 0.25em;
        align-items: center;
    }

    .grid-3-column {
        display: grid;
        grid-template-columns: auto min-content auto;
        width: 100%;
        gap: 0.25em;
        align-items: center;
    }

    .flex-column {
        display: flex;
        flex-direction: column;
        gap: var(--flex-gap);
    }

    .flex-row {
        display: flex;
        flex-direction: row;
        gap: var(--flex-gap);
    }

    .flex-row-centered {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: var(--flex-gap, 0.5em);
    }

    .gap-05 {
        gap: 0.5em;
    }

    .gap-1 {
        gap: 1em;
    }

    /* Full screen dialogs */

    .full-screen-dialog {
        --header-spacing: 0.5em;
        --body-spacing: 1em;
    }

    .full-screen-dialog::part(panel) {
        height: 100%;
        width: 100%;
        max-height: unset;
        max-width: unset;
    }

    .full-screen-dialog::part(body) {
        display: flex;
        flex-direction: column;
        justify-content: center;
        --width: 100vw;
        --height: 100vh;
    }

    @media only screen and (max-width: 600px) {
        .full-screen-dialog::part(body) {
            padding: 0;
        }
    }

    /* width */
    ::-webkit-scrollbar {
        background: var(--scrollbar-track-bg-color);
        width: var(--scrollbar-width);
        height: var(--scrollbar-width);
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: var(--scrollbar-track-bg-color);
        border-radius: var(--scrollbar-radius);
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: var(--scrollbar-thumb-bg-color);
        border-radius: var(--scrollbar-radius);
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: var(--scrollbar-thumb-hover-bg-color);
    }

    [hidden] {
        display: none !important;
    }

    /** Borderless button */
    sl-button.borderless::part(base) {
        /* Set design tokens for height and border width */
        --sl-input-height-medium: 48px;
        --sl-input-border-width: 4px;

        border: unset;
        background-color: transparent;
    }

    sl-button.borderless::part(base):hover {
        color: var(--ds-accent-color);
        border: unset;
        background-color: transparent;
    }

    sl-dialog::part(title) {
        color: white;
    }

    sl-dialog::part(header) {
        background-color: var(--surface-bg-color);
    }

    sl-dialog::part(close-button) {
        color: white;
    }

    sl-drawer::part(close-button) {
        color: white;
    }

    .cursor-pointer {
        cursor: pointer;
    }

    .ds-box-shadow {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    }

    .ds-border {
        border: var(--ds-border);
    }

    .small-screen {
        display: flex;
    }

    .width_100pc {
        width: 100%;
    }

    .height_100pc {
        height: 100%;
    }

    .medium-screen,
    .large-screen,
    .xlarge-screen {
        display: none;
    }

    @media only screen and (min-width: 640px) {
        .small-screen {
            display: flex;
        }
        .xlarge-screen,
        .medium-screen,
        .large-screen {
            display: none;
        }
    }

    @media only screen and (min-width: 768px) {
        .medium-screen {
            display: flex;
        }
        .xlarge-screen,
        .small-screen,
        .large-screen {
            display: none;
        }
    }

    @media only screen and (min-width: 1024px) {
        .large-screen {
            display: flex;
        }
        .xlarge-screen,
        .small-screen,
        .medium-screen {
            display: none;
        }
    }

    @media only screen and (min-width: 1280px) {
        .xlarge-screen {
            display: flex;
        }
        .small-screen,
        .medium-screen,
        .large-screen {
            display: none;
        }
    }
`;
